import { render, staticRenderFns } from "./ImageExpansion.vue?vue&type=template&id=65d23d26&scoped=true&"
import script from "./ImageExpansion.vue?vue&type=script&lang=js&"
export * from "./ImageExpansion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d23d26",
  null
  
)

export default component.exports